<template>
    <div class="guide-page" :class="[{ sidebar }, `directoin_${directoin}`]">
        <div class="g-content">
            <slot name="content"></slot>
        </div>
        <div class="g-sidebar">
            <div class="gs-li">
                <section class="gs-content logo">
                    <div class="gs-icon">
                        <span></span>
                    </div>
                </section>
                <section class="gs-content groupA line">
                    <div class="gs-icon" :class="{ highlight: index === highlightNav }" v-for="(item, index) of 7"
                        :key="index">
                        <span>
                            <i :class="`icon0${index + 1}`"></i>
                        </span>
                        <div class="guide-tip" v-if="tipVisible && index === highlightNav">
                            <div class="gt-text">{{ copywriting }}</div>
                            <div class="gt-opt">
                                <div class="sp1">1/2</div>
                                <div class="sp2" @click="handleNext">下一步</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="gs-li">
                <section class="gs-content groupB line">
                    <div class="gs-icon" v-for="(item, index) of 4" :key="index">
                        <span>
                            <i :class="`icon0${index + 1}`"></i>
                        </span>
                    </div>
                </section>
                <section class="gs-content groupC line">
                    <div class="gs-icon">
                        <span>
                            <i class="icon01"></i>
                        </span>
                    </div>
                    <div class="gs-icon">
                        <span>
                            <img class="icon02" :src="require('@/assets/images/guide_page/icon02c.png')" alt="" />
                        </span>
                    </div>
                </section>
            </div>
        </div>
        <div class="g-mask" :class="{ inner: !maskFull }">
            <div class="mask-content">
                <slot name="maskContent"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GuidePage',
    props: {
        copywriting: {
            type: String,
            default: 'AI写作，全新升级，点击即刻体验'
        },
        directoin: {
            type: [String, Number],
            default: 2, // 1, 左；2，右
        },
        sidebar: {
            type: Boolean,
            default: false
        },
        tipVisible: {
            type: Boolean,
            default: false
        },
        highlightNav: {
            type: Number,
            default: -1
        },
        maskFull: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        handleNext() {
            this.$emit('next')
        }
    }
}
</script>

<style lang="scss" scoped>
.guide-page {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-image: url(@/assets/images/common/bgi01.png);
    background-size: 100% 100%;

    &.sidebar {
        padding: 10px 52px 10px 10px;

        .g-sidebar {
            right: 0;
        }
    }

    &.directoin_1 {
        .g-sidebar {
            left: -52px;
            right: auto;

            .gs-content {
                &.groupA {
                    .gs-icon {
                        &.highlight {
                            .guide-tip {
                                right: auto;
                                left: 100%;
                                margin: -18px 0 0px 14px;
                                padding: 20px 20px 0 28px;
                                background-image: url(@/assets/images/guide_page/tip_bgi02_l@2x.png);
                            }
                        }
                    }
                }
            }
        }

        &.sidebar {
            padding: 10px 10px 10px 52px;

            .g-sidebar {
                left: 0;
                right: auto;
            }
        }

        .g-mask {

            &.inner {
                top: 10px;
                right: 10px;
                bottom: 10px;
                left: 52px;
                border-radius: 6px;
            }
        }
    }

    .g-content {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        background: #ffffff;
        background-image: url(@/assets/images/ai_search/ai_stick_bg.png);
        background-size: 100% 100%;
    }

    .g-sidebar {
        position: absolute;
        top: 10px;
        right: -52px;
        bottom: 10px;
        display: flex;
        align-items: center;
        flex-flow: column;
        justify-content: space-between;
        width: 52px;

        .gs-content {
            position: relative;
            display: flex;
            align-items: center;
            flex-flow: column;
            justify-content: center;

            .gs-icon {
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }

            &.logo {
                margin: 8px 0 12px 0;

                .gs-icon {
                    width: 32px;
                    height: 32px;
                    padding: 3px;

                    span {
                        width: 26px;
                        height: 26px;
                        background-image: url(@/assets/images/guide_page/logo.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }

            &.groupA {
                padding: 7px 0 0 0;

                .gs-icon {
                    margin: 9px 0;
                    padding: 2px;

                    span {
                        width: 26px;
                        height: 30px;
                        border: 1px solid rgba(0, 0, 0, 0.02);
                        border-radius: 100px;
                        background: rgba(255, 255, 255, 0.3);
                        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.02);

                        i {
                            width: 18px;
                            height: 18px;
                            background: #4e4b69;
                            mask-size: 100%;
                            mask-position: center center;

                            &.icon01 {
                                mask-image: url(@/assets/images/guide_page/icon01.svg);
                            }

                            &.icon02 {
                                mask-image: url(@/assets/images/guide_page/icon02.svg);
                            }

                            &.icon03 {
                                mask-image: url(@/assets/images/guide_page/icon03.svg);
                            }

                            &.icon04 {
                                mask-image: url(@/assets/images/guide_page/icon04.svg);
                            }

                            &.icon05 {
                                mask-image: url(@/assets/images/guide_page/icon05.svg);
                            }

                            &.icon06 {
                                mask-image: url(@/assets/images/guide_page/icon06.svg);
                            }

                            &.icon07 {
                                mask-image: url(@/assets/images/guide_page/icon07.svg);
                            }
                        }
                    }

                    &.highlight {
                        z-index: 99;
                        position: relative;

                        span {
                            background: #fff;
                        }

                        .guide-tip {
                            position: absolute;
                            top: 0;
                            right: 100%;
                            box-sizing: border-box;
                            width: 258px;
                            height: 132px;
                            margin: -18px 14px 0px 0px;
                            padding: 20px 28px 0 20px;
                            background-image: url(@/assets/images/guide_page/tip_bgi02@2x.png);
                            background-repeat: no-repeat;
                            background-size: 100% auto;

                            .gt-text {
                                color: #FFF;
                                font-size: 16px;
                                font-weight: 900;
                                line-height: 24px;
                            }

                            .gt-opt {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                margin: 16px 0 0 0;

                                div {
                                    &.sp1 {
                                        color: rgba(255, 255, 255, 0.60);
                                        font-size: 12px;
                                        font-weight: 500;
                                        line-height: 14px;
                                    }

                                    &.sp2 {
                                        font-size: 14px;
                                        font-weight: 900;
                                        line-height: 16px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 86px;
                                        height: 28px;
                                        transition: all 0.2s;
                                        color: #4a3aff;
                                        border-radius: 20px;
                                        background: #ffffff;
                                        cursor: pointer;

                                        &:hover {
                                            background: rgba(255, 255, 255, 0.8);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            &.groupB {
                padding: 10px 0;

                .gs-icon {
                    margin: 6px 0;

                    span {
                        width: 26px;
                        height: 26px;

                        i {
                            width: 16px;
                            height: 16px;
                            background: #4e4b69;
                            mask-size: 100%;
                            mask-position: center center;

                            &.icon01 {
                                mask-image: url(@/assets/images/guide_page/icon01b.svg);
                            }

                            &.icon02 {
                                mask-image: url(@/assets/images/guide_page/icon02b.svg);
                            }

                            &.icon03 {
                                mask-image: url(@/assets/images/guide_page/icon03b.svg);
                            }

                            &.icon04 {
                                mask-image: url(@/assets/images/guide_page/icon04b.svg);
                            }
                        }
                    }
                }
            }

            &.groupC {
                padding: 10px 0 2px 0;

                .gs-icon {
                    margin: 6px 0;

                    span {
                        width: 26px;
                        height: 26px;

                        i {
                            width: 22px;
                            height: 22px;

                            &.icon01 {
                                background: #bdbcd1;
                                mask-image: url(@/assets/images/guide_page/icon01c.svg);
                            }
                        }

                        img {
                            &.icon02 {
                                width: 22px;
                                height: 22px;
                                border-radius: 50%;
                                background: rgba(255, 255, 255, 0.6);
                                object-fit: cover;
                            }
                        }
                    }
                }
            }

            &.line {
                &::before {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    width: 32px;
                    height: 0.5px;
                    content: '';
                    transform: translateX(-50%);
                    background: linear-gradient(90deg,
                            rgba(177, 191, 222, 0) 0%,
                            #b1bfde 50.17%,
                            rgba(177, 191, 222, 0) 100%);
                }
            }
        }
    }

    .g-mask {
        position: fixed;
        z-index: 9;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 6px;

        &.inner {
            top: 10px;
            right: 52px;
            bottom: 10px;
            left: 10px;
            border-radius: 6px;
        }

        .mask-content {
            position: relative;
            width: 100%;
            height: 100%;
        }
    }
}
</style>